
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/caucus/buy",
      function () {
        return require("private-next-pages/caucus/buy.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/caucus/buy"])
      });
    }
  